import { t } from "@repo/translation";

import { type GroupedTags, type Tags } from "./types";

const TAG_GLOBAL = "GLOBAL";
const TAG_GLOBAL_PREFIX = "tags.global.";
const TAG_LOCALE_PREFIX = (market: string) => `tags.${market}.`;

export const getMatchingTranslationforTags = (
  filteredTag: string,
  tags: Tags[],
  market: string
) => {
  if (filteredTag && tags) {
    const matchingTag = tags.find(
      (tag) => tag.name.toLowerCase() === filteredTag.toLowerCase()
    );
    return matchingTag?.translationKey
      ? generateTagTranslation(matchingTag, market)
      : filteredTag;
  }
};

export const getTagTranslation = (
  opportunityTags: string[] | undefined,
  tags: Tags[] | undefined,
  market: string
) => {
  if (opportunityTags && tags) {
    const translationKeys = opportunityTags.map((opportunityTag) => {
      return getMatchingTranslationforTags(opportunityTag, tags, market);
    });
    return translationKeys.join(", ");
  }
};

export const generateTagTranslation = (tag: any, market: string) => {
  return `${getTagGroupTranslationString(tag.type, market, tag.countryCode)} -
  ${t(tag?.translationKey)}`;
};

export const groupObjectsByType = (objects: any) => {
  const groupedObjects: GroupedTags = {};

  for (const obj of objects) {
    if (!groupedObjects[obj.type]) {
      groupedObjects[obj.type] = [];
    }
    groupedObjects[obj.type].push(obj);
  }
  return groupedObjects;
};

export const getTagGroupName = (
  type: string,
  groups: GroupedTags,
  market: string
) => {
  return getTagGroupTranslationString(
    type,
    market,
    groups[type][0].countryCode
  );
};

const getTagGroupTranslationString = (
  type: string,
  market: string,
  countryCode: string
) => {
  return countryCode === TAG_GLOBAL
    ? t(TAG_GLOBAL_PREFIX + type)
    : t(TAG_LOCALE_PREFIX(market) + type);
};

export const filterTagsByCustomerType = (
  tags: Tags[],
  customerType?: string
): Tags[] => {
  if (!customerType) {
    return tags;
  }
  return tags.filter((tag) => tag.customerType === customerType);
};
